import FLMasterPage from '../pages/flight_master';
export default [
    {
        path:'/flight/master',
        exact:true,
        Component:FLMasterPage
    },
]